import React, { useState } from 'react';
import './style.scoped.scss';
import { ACCOUNT_NAVIGATION } from '../../../assets/constants/strings';
import SettingsTitle from '../SettingsTitle';
import UserInfo from '../../Dashboard/UserInfo';
import { HiDocumentText, HiOutlineChatAlt2, HiShare } from 'react-icons/hi';
import CreditsModal from './CreditsModal';
import { MdSummarize } from 'react-icons/md';

const UsageStatus = ({ user }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className='usage-frame' id='usage-frame'>
      <SettingsTitle title={ACCOUNT_NAVIGATION.USAGE.TITLE} />
      <p>
        The below usage stats are for the current billing cycle (from{' '}
        {user.userPlan.startedAt} -{' '}
        {user.userPlan.subscriptionName === 'Free'
          ? user.userPlan.endDate
          : user.userPlan.nextBilling}
        )
      </p>
      <UserInfo
        icon={<HiDocumentText />}
        title='Pages of Regulations Visited'
        percentage={
          (user.userUsage.pageviews / user.userPlan.restrictions.pageviews) *
          100
        }
        progressBarText={`${user.userUsage.pageviews} out of ${user.userPlan.restrictions.pageviews}`}
        barColor='#123466'
        barId='visited'
        showBtn
      />
      <UserInfo
        iconId='pages-shared'
        icon={<HiShare />}
        title='Pages Shared'
        percentage={
          (user.userUsage.shares / user.userPlan.restrictions.shares) *
          100
        }
        progressBarText={`${user.userUsage.shares} out of ${user.userPlan.restrictions.shares}`}
        barColor='#ff7a00'
        barId='shared'
      />
      <UserInfo
        iconId='ai-queries'
        icon={<HiOutlineChatAlt2 />}
        title='AI Queries'
        percentage={
          (user.userUsage.queries / user.userPlan.restrictions.queries) * 100
        }
        progressBarText={`${user.userUsage.queries} out of ${user.userPlan.restrictions.queries}`}
        barColor='#00a587'
        barId='queries'
        showQueriesBtn
        handleClick={() => setShowModal(true)}
      />
      <UserInfo
        iconId='ai-summaries'
        icon={<MdSummarize />}
        title='AI Summaries'
        percentage={
          (user.userUsage.summaries / user.userPlan.restrictions.summaries) *
          100
        }
        progressBarText={`${user.userUsage.summaries} out of ${user.userPlan.restrictions.summaries}`}
        barColor='#00a587'
        barId='summary'
      />

      <CreditsModal show={showModal} handleClose={() => setShowModal(false)} />
    </div>
  );
};

export default UsageStatus;
